import { TableCell, TableRow } from '@material-ui/core';
import { formatDateTimeReadable, Webhook } from '@nemuru-eng/js-api-client';

import { ActionHandleProps } from '@/components/modules/Webhooks/components/WebhooksTable/components/Body';
import { getWebhookAuthorization } from '@/components/modules/Webhooks/services/getWebhookAuthorization';
import { MoreActionsMenuWithIcon } from '@/components/shared/components/MoreActionsMenu/MoreActionsMenuWithIcon';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';
import { DefaultTableProps } from '@/types/defaultTableProps';

interface RowProps {
  webhook: Webhook;
  handleEdit: (item: ActionHandleProps) => void;
  handleDelete: (item: ActionHandleProps) => void;
  tableProps: Omit<DefaultTableProps, 'isScrollable'>;
  deleteView?: boolean;
}

export const Row = ({ webhook, handleEdit, handleDelete, tableProps, deleteView }: RowProps) => {
  const { isMobile } = useScreen();

  const { classes } = tableProps;

  const actionsOptionsArrayByIndex = () => {
    return [
      {
        display: <Text tId={'EDIT_WEBHOOK'} />,
        iconName: 'edit',
        onClick: () => handleEdit({ item: webhook }),
      },
      {
        display: <Text tId={'DELETE_WEBHOOK'} />,
        iconName: 'delete',
        onClick: () => handleDelete({ item: webhook }),
      },
    ];
  };

  const desktopItemRow = (
    <TableRow key={webhook.id} className={classes.root}>
      <TableCell align="left">
        <Font variant={'body2'}>{formatDateTimeReadable(webhook.createdAt)}</Font>
      </TableCell>
      <TableCell align="left">
        <Font variant={'body2'}>
          <code>{webhook.target}</code>
        </Font>
      </TableCell>
      <TableCell align="left">
        <Font variant={'body2'}>
          <Text tId={`AuthorizationType_${getWebhookAuthorization(webhook).authorizationType}`} />
        </Font>
      </TableCell>
      {!deleteView && (
        <TableCell align={'right'}>
          <MoreActionsMenuWithIcon actionsOptionsArray={actionsOptionsArrayByIndex()} />
        </TableCell>
      )}
    </TableRow>
  );

  const mobileItemRow = desktopItemRow;

  return isMobile ? mobileItemRow : desktopItemRow;
};
